export default {
  unauthorizedAdmin: [],
  admin: [
    {
      path: 'order',
      name: 'admin.order-list',
      component: () => import('modules/order/views/admin/orderList.vue'),
    },
    {
      path: 'order/create',
      name: 'admin.order-create',
      meta: {
        mode: 'create',
      },
      component: () => import('modules/order/views/admin/orderForm.vue'),
    },
    {
      path: 'order/update/:id',
      name: 'admin.order-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/order/views/admin/orderForm.vue'),
    },
  ],
}